// extracted by mini-css-extract-plugin
module.exports = {"fullScreen":"style_fullScreen__E0ZCz","fade":"style_fade__65ZHK"};